<template>
  <v-container fluid>
    <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir variables
        </v-btn>
      </v-col>
    </v-row>

    <br />

    <!-- :search="search" -->
    <v-data-table
      show-expand
      single-expand
      :headers="headers"
      :items="VarNamesList"
      item-key="id"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100],
      }"
    >
      <!-- <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template> -->

      <template v-slot:expanded-item="{ item }">
        <td colspan="100%">
          <v-row dense no-gutters class="w-100">
            <v-col
              v-for="i in 10"
              :key="i"
              cols="12"
              md="2"
              lg="4"
              xl="3"
              class="py-4"
            >
              <v-row class="pl-10">
                <v-col cols="12" class="py-2">
                  <h5 class="text-subtitle-2 pb-0 my-0 primary--text">
                    Var{{ i }}
                  </h5>
                </v-col>

                <v-col cols="12" class="pl-3 py-0">
                  <p class="my-0">
                    {{ item[`var${i}`] }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </td>
      </template>

      <template v-slot:[`item.client_id`]="{ item }">
        {{ getClientName(item.client_id) }}
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleEdit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'error' : 'blue-grey'"
            @click.stop="handleDelete(item)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-hover>
      </template>
    </v-data-table>

    <btnregister
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="eventToEdit"
      @close:dialog="closeFormDialog"
    ></btnregister>
  </v-container>
</template>

<script>
import axios from "axios";
import btnregister from "./btnregister.vue";
// import btnupdate from '@/components/auth/user/btnupdate.vue';

export default {
  components: {
    btnregister,
    // btnupdate,
  },

  data: () => ({
    isLoading: false,
    isOpenForm: false,
    isEditMode: false,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    VarNamesList: [],
    eventToEdit: {},
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "left",
        value: "name",
        class: "primary--text",
        width: "30%",
      },
      {
        text: "Cliente",
        align: "left",
        value: "client_id",
        class: "primary--text",
        width: "30%",
      },
      {
        text: "Campaña",
        align: "left",
        value: "campaign_id",
        class: "primary--text",
        width: "25%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getVarNamesList();
      },
      deep: true,
    },
  },

  computed: {
    Clients() {
      return this.$store.getters["clients/GET_ALL_CLIENTS"];
    },

    getClientName() {
      return (clientId) => {
        const client = this.Clients.find(c => c.id === clientId);
        return client ? client.name : "Desconocido"; // Retorna el nombre o un valor por defecto
      };
    }
  },

  created() {
    this.getVarNamesList();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    async GetClients() {
      try {
        const response = await this.$store.dispatch("clients/SHOW_CLIENTS");
        this.data = response.data;
        this.isLoadingClients = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.eventToEdit = item;
      this.openFormDialog();
    },

    async handleDelete(event) {
      const accessToken = localStorage.getItem("token");

      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar esta configuración de variables? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          axios
            .delete(
              `${process.env.VUE_APP_ROOTAPI}/campaign/campaign_variable/${event.id}`,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            )
            .then((res) => {
              this.getVarNamesList();
              this.$snotify.success("Configuración eliminada", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error(
                "Hubo un error al eliminar esta configuración.",
                "Error"
              );
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar la configuración.", "¡Error!");
        // console.error(error);
      }
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode)
        this.VarNamesList = this.VarNamesList.map(
          (el) => (el.id === data.id ? data : el)
        );
      if (data && !this.isEditMode)
        this.VarNamesList = [
          ...this.VarNamesList,
          data,
        ];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.eventToEdit = {};
    },

    getVarNamesList() {
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/campaign/campaign_variable`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            page,
            itemPerPage: itemsPerPage,
            // type: this.searchType,
            // value: this.search,
          },
        })
        .then((res) => {
          this.VarNamesList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
